import { StorageService } from './core/storageService';
import { CONVERSATION_CACHE_MS } from '../config/security';
import { licenseKeyPrefix } from '../utils/helpers';

export class SessionService {
  constructor(licenseToken, httpClient) {
    this.licenseToken = licenseToken;
    this.httpClient = httpClient;
    this.storage = new StorageService('tiagpc');
    this.sessionToken = this._getOrCreateSessionToken();
  }


  _generateSessionToken() {
    return 'session_' + Array.from(crypto.getRandomValues(new Uint8Array(28)))
      .map(b => b.toString(16).padStart(2, '0'))
      .join('');
  }


  _getSessionKey() {
    return `session_${licenseKeyPrefix(this.licenseToken)}`;
  }


  _getOrCreateSessionToken() {
    const key = this._getSessionKey();
    const stored = this.storage.get(key);

    if (stored && stored.sessionToken) {
      return stored.sessionToken;
    }

    const newToken = this._generateSessionToken();
    this._saveSessionToken(newToken, false);
    return newToken;
  }


  _saveSessionToken(sessionToken, validated = false) {
    const key = this._getSessionKey();
    this.storage.set(key, {
      sessionToken,
      timestamp: Date.now(),
      validated
    });
  }


  hasValidCachedSession() {
    const key = this._getSessionKey();
    const stored = this.storage.get(key);

    if (!stored) {
      return false;
    }

    const { validated, timestamp } = stored;
    const now = Date.now();
    return validated && (now - timestamp < CONVERSATION_CACHE_MS);
  }


  async validateSession() {
    try {
      const response = await this.httpClient.post('/validate-session', {
        session_token: this.sessionToken
      });
      return response;
    } catch (error) {
      this.clearSession();
      return { success: false, valid: false };
    }
  }


  validateSessionLocally() {
    this._saveSessionToken(this.sessionToken, true);
  }


  resetValidation() {
    this._saveSessionToken(this.sessionToken, false);
  }


  getSessionToken() {
    return this.sessionToken;
  }


  renewSessionToken() {
    const newToken = this._generateSessionToken();
    this.sessionToken = newToken;
    this._saveSessionToken(newToken, false);
    return newToken;
  }


  clearSession() {
    const key = this._getSessionKey();
    this.storage.remove(key);
  }


  async releaseSession() {
    if (!this.licenseToken) {
      console.warn('[SessionService] No license token available to release session');
      return;
    }

    try {
      const response = await this.httpClient.post('/release-session', {
        session_token: this.sessionToken
      });
      return response;
    } catch (error) {
      console.error('[SessionService] Failed to release session:', error.message);
    }
  }
}
